import styled from '@emotion/styled';
import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const Section = styled.section`
	margin-left: auto;
	margin-right: auto;
	padding: 30px 15px 15px;
	width: 100%;
	.container {
		max-width: 970px;
		margin-left: auto;
		margin-right: auto;
		padding-left: 15px;
		padding-right: 15px;
		width: 100%;
	}
	.align-container {
		display: flex;
		flex-wrap: wrap;
	}
	.reference-card-item {
		width: 470px;
		padding-right: 15px;
		padding-bottom: 15px;
	}
	.reference-card-section-heading {
		text-align: left;
		margin-bottom: 22px;
		align-items: center;
		flex-direction: row;
		justify-content: space-between;
		display: flex;
		.back-to-home {
			padding-right: 15px;
		}
	}
	@media (min-width: 992px) {
		max-width: 970px;
	}
	@media (min-width: 768px) and (max-width: 991px) {
		max-width: 720px;
		.reference-card-item {
			width: 345px !important;
		}
	}
	@media (max-width: 767px) {
		.reference-card-item {
			padding-right: 0px;
		}
	}
	@media (min-width: 576px) and (max-width: 768px) {
		max-width: 540px;
		.reference-card-item {
			width: 100% !important;
		}
	}
`;

const BackgroundImage = styled.div`
	display: flex;
	align-items: flex-end;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	position: relative;
	opacity: 0.99;
	height: 288px;
	padding: 1.5rem;
	background-image: ${({ url }) => `url(${url})`};
	@media (max-width: 767px) {
		background-image: ${({ mobileUrl, url }) => `url(${mobileUrl || url})`};
	}
	.reference-card-title {
		color: #fff;
		margin: 0;
		font-size: 1.7rem;
		text-align: left;
		line-height: 2rem;
	}
`;

const CategoryContainer = styled.div`
	background-color: #fff;
	border: 1px solid #ccc;
	.reference-card-content {
		padding: 20px;
		h2 {
			text-transform: none;
			font-size: 20px;
			font-weight: 600;
			line-height: 27.24px;
			text-align: left;
		}
	}
	.reference-card-content-text {
		margin: 0 0 10px 0;
		text-align: left;
	}
	.reference-card-promo {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding-top: 20px;
		border-top: 1px solid #ccc;
		border-top-width: 1px;
		border-top-style: solid;
		border-top-color: rgb(204, 204, 204);

		a {
			border-radius: 0;
		}
	}
`;

const CategoryViewCard = ({ cardDetails }) => {
	return (
		<CategoryContainer className='h-100 reference-card-background'>
			<BackgroundImage url={cardDetails?.image} mobileUrl={cardDetails?.image}>
				<p className='reference-card-subtitle'></p>
				<div className='black-opacity' />
			</BackgroundImage>

			<div className='reference-card-content'>
				{cardDetails?.title && <h2>{cardDetails?.title}</h2>}
				{cardDetails?.description && (
					<p className='reference-card-content-text'>
						{cardDetails?.description}
					</p>
				)}
				<div className='reference-card-promo'>
					<span>
						<Link to={`/blog/${cardDetails.title}`} className='btn btn-red '>
							READ MORE
						</Link>
					</span>
				</div>
			</div>
		</CategoryContainer>
	);
};

const BlogCategories = ({ categories }) => {
	return (
		<Section>
			<div className='pt-5 pb-5'>
				<div className='ml-md-0 align-container'>
					{categories?.map((card, index) => (
						<div className='pb-4 pl-md-0 reference-card-item' key={index}>
							<CategoryViewCard cardDetails={card} />
						</div>
					))}
				</div>
				{(!categories || categories?.length === 0) && (
					<div className='alert alert-info m-20'>No blog items found.</div>
				)}
			</div>
		</Section>
	);
};

export default BlogCategories;
